import React, { useState, useEffect } from 'react';
import { DiscoverWithMegaMenu } from './MegaMenu';
import {
  Box,
  Drawer,
  Link,
  Modal,
  Typography,
  IconButton,
} from '@mui/material';
import { MenuOpen, Close, Search } from '@mui/icons-material';
import SearchBar from './SearchBar.jsx';
import { __ } from '../../Lang.js';

const InternalNav = ({ isLoggedIn = false }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const NavLinks = () => (
    <>
      <Link
        href="#"
        className="internal-nav__link"
        underline="none"
        sx={{ color: 'white' }}
        onClick={(e) => {
          e.preventDefault();
          // If an inline search bar is present (e.g. the results page), focus
          // it instead of opening the modal. Detect this by the actual presence
          // of the input, not by the URL: a watch page reached from a search
          // also carries `search=` in its URL but has no inline search bar.
          const searchBar = document.querySelector('input[name="search"]');
          if (searchBar) {
            searchBar.focus();
            searchBar.classList.add('search-bar-focused');
            setTimeout(() => searchBar.classList.remove('search-bar-focused'), 300);
            return;
          }
          setModalOpen(true);
        }}
      >
          <Search className="internal-nav__icon" />
        {__('Search')}
      </Link>
      { isLoggedIn &&
      (
          <Link href="/app/twi/results?type=unplayed" className="internal-nav__link" underline="none" sx={{ color: 'white' }}>{__('New to Me')}</Link>
      )
      }
      { isLoggedIn &&
      (
          <Link href="/app/twi/results?type=continue" className="internal-nav__link" underline="none" sx={{ color: 'white' }}>{ __('Continue Watching') }</Link>
      )
       }
      <Link href="/app/twi/results?type=recent" className="internal-nav__link" underline="none" sx={{ color: 'white' }}>
        {__('Recent')}
      </Link>

      {isLoggedIn && (
        <Link href={__('/media/videos/account/')} className="internal-nav__link" underline="none" sx={{ color: 'white' }}>
          {__('Manage Plan')}
        </Link>
      )}
      <DiscoverWithMegaMenu isLoggedIn={isLoggedIn} />
    </>
  );

  return (
    <div className="internal-nav">
      {isMobile ? (
        <>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: 'white' }}>
              <MenuOpen />
            </IconButton>
            <Typography variant="caption" sx={{ color: 'white', fontSize: '10px' }}>
              MENU
            </Typography>
          </Box>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          PaperProps={{
            sx: {
              backgroundColor: '#fff',
            },
          }}
        >
          <Box sx={{ width: 280, p: 2 }}>
            <IconButton onClick={() => setDrawerOpen(false)}>
              <Close sx={{ color: '#222' }} />
            </IconButton>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <NavLinks />
            </Box>
          </Box>
        </Drawer>
        </>
      ) : (
        <NavLinks />
      )}

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="search-modal-title"
        aria-describedby="search-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(5px)',
        }}
      >
        <Box className="search-modal" color="primary">
          <Typography id="search-modal-title" variant="h6" component="h2">
            {__('Search Videos')}
          </Typography>
              <SearchBar 
                  searchQuery={""}
                  defaultSearchQuery={""}
                  setSearchQuery={(query) => {
                    //full url
                      window.location.href = window.location.origin + '/app/twi/results?search=' + encodeURIComponent(query);
                    }
                  }

                  // the callback to update the grid with videos and playlists
                  updateGrid={() => {
                      // this is a no-op in the modal, as the search bar redirects
                      // to the search results page
                  }}

                  // the global loading state
                  setLoading={() => {
                      // this is also a no-op in the modal, as the search bar redirects
                      // to the search results page
                  }}

              />
        </Box>
      </Modal>
    </div>
  );
};

export default InternalNav;